import React, { useState } from "react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  updateDoc,
  writeBatch,
  serverTimestamp,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { firestore, GeoFirestore } from "../../../../firebase";
import firebase from "firebase/compat/app";
import ngeohash from "ngeohash";
import DisplayEventsFromXml from "./displayEventsFromXml";

const db = firestore;

const UniversalEventScraper = ({ currentBusinessID, businessLocations }) => {
  const [xmlUrl, setXmlUrl] = useState("");
  const [eventsData, setEventsData] = useState([]);
  const [scrapingLoading, setScrapingLoading] = useState(false);
  const [loadingFinished, setLoadingFinished] = useState(false);
  const [apiLink, setApiLink] = useState("");

  const [eventLocation, setEventLocation] = useState(null);
  const [dataConfig, setDataConfig] = useState({
    title: "",
    description: "",
    age: "",
    date: "",
    ticketUrl: "",
    mainImage: "",
    price: "",
    location: "",
  });

  const onFetchFromEvent = async () => {
    console.log(eventLocation.id);
    console.log(eventLocation.data());
    setScrapingLoading(true);
    const res = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/registerVenue",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          locationId: currentBusinessID,
          // programUrl: "https://konserthus.stormen.no/program",
          // programUrl: "https://www.kulturhusetibergen.no/program",
          // programUrl: "https://www.forumscene.no/arrangementer",
          // programUrl: "https://kulturhuset.tr.no/",
          // programUrl: "https://www.usf.no/api/eventsEdge?",
          // "https://www.broadcast.events/api/domain/events?venueId=Mowir4BL0V&limit=1000&skip=0",
          // programUrl:
          //   "https://www.broadcast.events/api/domain/events?venueId=5sn0n9A2Mc&limit=1000&skip=0?",
          programUrl: apiLink,
          venueName: eventLocation.data().locationName,
          staticData: {
            eventOrganiser: eventLocation.id,
            eventOrganiserName: eventLocation.data().locationName,
            g: eventLocation.data().g,
            lat: eventLocation.data().lat,
            lng: eventLocation.data().lng,
            coordinates: eventLocation.data().coordinates,
          },
        }),
      },
    );
    console.log(await res.json());

    // 2. Scrape all — needs POST
    const res2 = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/scrapeAll",
      { method: "POST" }, // ← this was missing
    );
    console.log(await res2.json());

    // 3. Get events
    const res3 = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getEvents?upcoming=true",
    );
    console.log(await res3.json());
    setScrapingLoading(false);
    setLoadingFinished(true);
  };

  return eventLocation == null ? (
    businessLocations.length > 0 ? (
      businessLocations.map((lokasjonsInformasjon, rowIndex) => {
        return (
          <div key={rowIndex} className='box' style={{ marginBottom: "15px" }}>
            <div className='businessOverView'>
              <label className='locationNameLabel'>
                {lokasjonsInformasjon.data()?.locationName}
              </label>
              <label>
                {lokasjonsInformasjon.data()?.adress
                  ? lokasjonsInformasjon.data()?.adress
                  : "-"}
              </label>
              <div>
                <a
                  onClick={() => {
                    setEventLocation(lokasjonsInformasjon);
                  }}
                  className='universalButtonRed'
                  style={{ marginLeft: "5px" }}>
                  Velg
                </a>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <p style={{ textAlign: "center", marginTop: 0 }}>
        Ingen lokasjoner å vise til
      </p>
    )
  ) : (
    <div>
      <label style={{ display: "block", marginBottom: "5px" }}>
        Lim inn API-link her:
      </label>
      <input
        type='text'
        value={apiLink}
        onChange={(e) => setApiLink(e.target.value)}
        placeholder='https://www.example.com/api/events'
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      />
      <button onClick={onFetchFromEvent}>Hent arrangementer</button>
      {scrapingLoading && <p>Scraping in progress...</p>}
      {loadingFinished && (
        <p>
          Scraping finished! Check console for results.{" "}
          <a href='/MyBusiness/events/'>Gå tilbake</a>
        </p>
      )}
    </div>
  );
};

export default UniversalEventScraper;
